import { useState, useEffect } from "react";
import { useAvtovazRequisites } from "~/entity/AvtovazRequisites";
import { useDealer } from "~/entity/Dealer";

export const useDefaultDataContract = (id: string) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const { getAvtovazActiveRequisiteList } = useAvtovazRequisites();
  const { getById } = useDealer();

  const fetchData = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const params = new URLSearchParams();
      params.append("id", id);

      const [responseActiveRequisite, responseDealer] = await Promise.all([
        getAvtovazActiveRequisiteList(),
        getById(params.toString()),
      ]);

      if (
        responseActiveRequisite.status &&
        responseActiveRequisite.status >= 400
      ) {
        throw new Error(`${responseActiveRequisite.status}`);
      }

      if (responseDealer.status && responseDealer.status >= 400) {
        throw new Error(`${responseDealer.status}`);
      }

      const { inn, code, dealerName, category, main } = responseDealer.data;

      setData({
        requisite: responseActiveRequisite.data,
        dataMain: {
          inn,
          code,
          name: dealerName,
          category,
          isHeadCompany: main === 1 ? "Да" : "Нет",
        },
      });
    } catch (error) {
      setError("Ошибка загрузки первичных данных");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id, getAvtovazActiveRequisiteList, getById]);

  return { data, isLoading, error };
};
